// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__zU6MA","noInteraction":"EventWrapper_noInteraction__ShXcl"};